module.exports = __webpack_public_path__ + "img/gameboard.97353bc3.jpg";